import { jsxs as w, jsx as d } from "react/jsx-runtime";
import k from "classnames";
import x, { useMemo as T } from "react";
import "@jetbrains/ring-ui-built/components/global/theme.js";
import "../Theme/ThemeContext.js";
import { useScaleFactor as N } from "../../hooks/useScaleFactor.js";
import "lz-string";
import n from "./Skeleton.module.css.js";
const l = 200, _ = "skeleton", H = x.memo((a) => {
  const {
    circle: e = !1,
    className: c = "",
    innerRadius: m,
    outerRadius: h,
    width: u,
    height: p
  } = a, f = N(), R = (i, S = f) => i != null ? i * S : void 0, [o, t, s, r] = [
    m,
    h,
    u,
    p
  ].map((i) => R(i)), g = e ? {
    borderRadius: "50%",
    height: t ? t * 2 : void 0,
    width: t ? t * 2 : void 0
  } : { height: r, width: s }, v = e ? {
    height: t ? t * 2 : void 0,
    width: t ? t * 2 + l : void 0
  } : { height: r, width: s ? s + l : void 0 }, y = T(() => {
    if (e && o && t) {
      const i = Math.min(o, t);
      return {
        height: i * 2,
        left: t - i + "px",
        top: t - i + "px",
        width: i * 2
      };
    } else
      return { display: "none" };
  }, [e, o, t]);
  return /* @__PURE__ */ w(
    "div",
    {
      className: k(n.container, c),
      style: g,
      "data-test": a["data-test"] ?? _,
      children: [
        /* @__PURE__ */ d("div", { className: n.background, style: v }),
        /* @__PURE__ */ d("div", { className: n.innerCircle, style: y })
      ]
    }
  );
});
export {
  H as Skeleton
};
